var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorColor = function SvgErrorColor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-20": 13,
    "data-width-24": 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FC5A5A",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 8c0-.265.111-.52.309-.707.197-.188.465-.293.744-.293h7.894c.279 0 .547.105.745.293A.98.98 0 0 1 13 8c0 .265-.111.52-.309.707a1.08 1.08 0 0 1-.744.293H4.053c-.279 0-.547-.105-.744-.293A.98.98 0 0 1 3 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorColor);
export default ForwardRef;